import React from 'react';
import { useTranslation } from 'react-i18next';
import WelcomeHeader from '../components/layout/WelcomeHeader';
import styles from './InfoPage.module.css';

function Terms({ loggedIn, username }) {
  const { t } = useTranslation();
  return (
    <>
      <WelcomeHeader loggedIn={loggedIn} username={username} />
      <div className={styles.pageContainer}>
        <div className={styles.contentWrapper}>
          <h1 className={styles.pageTitle}>{t('termsPage.title')}</h1>
          <div className={styles.content}>
            <p><em>{t('termsPage.lastUpdated')}</em></p>

            <h2>{t('termsPage.s1Title')}</h2>
            <p>{t('termsPage.s1Text')}</p>

            <h2>{t('termsPage.s2Title')}</h2>
            <p>{t('termsPage.s2Intro')}</p>
            <ul>
              <li>{t('termsPage.s2Item1')}</li>
              <li>{t('termsPage.s2Item2')}</li>
              <li>{t('termsPage.s2Item3')}</li>
              <li>{t('termsPage.s2Item4')}</li>
              <li>{t('termsPage.s2Item5')}</li>
            </ul>

            <h2>{t('termsPage.s3Title')}</h2>
            <p>{t('termsPage.s3Text1')}</p>
            <p>{t('termsPage.s3Text2')}</p>

            <h2>{t('termsPage.s4Title')}</h2>
            <p>{t('termsPage.s4Intro')}</p>
            <ul>
              <li>{t('termsPage.s4Item1')}</li>
              <li>{t('termsPage.s4Item2')}</li>
              <li>{t('termsPage.s4Item3')}</li>
              <li>{t('termsPage.s4Item4')}</li>
              <li>{t('termsPage.s4Item5')}</li>
            </ul>

            <h2>{t('termsPage.s5Title')}</h2>
            <p>{t('termsPage.s5Text')}</p>

            <h2>{t('termsPage.s6Title')}</h2>
            <p>{t('termsPage.s6Text')}</p>

            <h2>{t('termsPage.s7Title')}</h2>
            <p>{t('termsPage.s7Text')}</p>

            <h2>{t('termsPage.s8Title')}</h2>
            <p>{t('termsPage.s8Text')}</p>

            <h2>{t('termsPage.s9Title')}</h2>
            <p>{t('termsPage.s9Text')}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Terms;
